module.exports = __webpack_public_path__ + "img/9_clubs.e9958310.png";